export const comments_3278342 = {"data":{"data":[],"links":{}}}